enum ContentType {
  Text, // 单个内容
  File, // 多个文章
  Url, // 网站
  Company, // 公司
  Download, // 下载
}
export default ContentType;
